import React from "react";
import { Container, Row, Col, Form, Label, Input, Button } from "reactstrap";
import RavenPhoto from '../../img/team/Raven-BW-Square-sm.jpg';
import JeremyPhoto from '../../img/team/jeremy-bw-sq-sm.jpeg';




class Features extends React.Component {
  render() {
    const iconStyle = { color: "#fff" };
    const iconSize = 50;

    return (
      <div className="agency-about-team" id="Team">
        <Container>
          <h4>
            The Founders
          </h4>
          <hr />
          <h3>
          Our team is experienced in building financial products & software
          </h3> 
          <Row>
            <Col md={6} className="team-member">
              <div className="member">
                <div className="mask">
                  <a href="https://twitter.com/says_theraven">
                    <i className="fa fa-twitter"></i>
                  </a>
                  <a href="https://www.linkedin.com/in/raven-smith-6511011">
                    <i className="fa fa-linkedin"></i>
                  </a>
                </div>
                <img src={RavenPhoto} width="100%" height="100%" />
              </div>
              <div className="name">
                Raven Smith
              </div>
              <div className="description">
              Raven is a financial services expert, who has spent most of her career building and distributing new consumer financial products. She also has experience in a B2B environment, including spending three years as a strategy and innovation consultant at Innosight, where she helped large companies create new growth businesses in brilliantly disruptive ways. She holds an MBA from Harvard, and she’s passionate about sharing access to the knowledge and tools that help everyone live their best financial life. 
              
              </div>
            </Col>
            <Col md={6} className="team-member">

              <div className="member">
                <div className="mask">
                  <a href="https://twitter.com/all9lives">
                    <i className="fa fa-twitter"></i>
                  </a>
                  <a href="https://www.linkedin.com/in/jeremybrennan/">
                    <i className="fa fa-linkedin"></i>
                  </a>
                </div>
                <img src={JeremyPhoto} width="100%" height="100%" />
              </div>
              <div className="name">
                Jeremy Brennan
              </div>
              <div className="description">
              Jeremy is a techie with a background in finance and media. He worked at Excite and Citigroup, before joining LearnVest, a subscription based financial planning platform acquired by Northwestern Mutual in 2015. As the company’s second engineer, Jeremy helped build both LearnVest’s tech platform and team. He believes that with the right tools, we can all be more successful—both financially and in our relationships.
              </div>
            </Col>   
          </Row>      
        </Container>
      </div>
    );
  }
}

export default Features;



// WEBPACK FOOTER //
// ./src/components/About/Team.jsx